import { pathOr, propOr } from 'ramda'

const getErrorMessage = ({ message, response }) => {
  if (response && response.errors) {
    const error = response.errors[0]
    return error.message
      ? error.message
      : message
  }

  return message
}

const getErrorStatus = ({ response, status }) => {
  if (response) {
    return response.status
  }

  return status
}

const getErrorUrl = ({ response }) => {
  if (response && response.url) {
    return response.response.url
  }

  return null
}

const getErrorName = propOr('unknown', 'name')

const getErrorType = pathOr('unknown', ['response', 'errors', 0, 'type'])

export {
  getErrorMessage,
  getErrorName,
  getErrorStatus,
  getErrorUrl,
  getErrorType,
}
